/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {DataRowType} from '../props';

export interface ITableCellDropdown {
  row: DataRowType;
  title?: string;
  icon?: JSX.Element;
  Component: (props: any) => JSX.Element; //eslint-disable-line
  keys: string[];
  action?: (key: string) => void;
  componentProps?: Record<string, unknown>;
}

export const TableCellDropdown = ({
  title = '',
  Component,
  keys,
  action,
  componentProps,
  row
}: ITableCellDropdown): JSX.Element => {
  const data = {} as Record<string, unknown>;

  keys.forEach(value => {
    data[value] = row[value];
  });

  if (data.showDropdown !== undefined) {
    return data.showDropdown ? <Component title={title} data={data} action={action} {...componentProps} /> : null;
  }

  return <Component title={title} data={data} action={action} {...componentProps} />;
};